import { combineReducers } from 'redux';

import { BankingState } from '@/global/models/IBankingSteps';
import bankingReducer from '@/store/redux/slices/pages/banking';

export interface BankingCombinedState {
  page: BankingState;
}

const combinedReducers = combineReducers({
  page: bankingReducer,
});

export default combinedReducers;
